import { useState, useEffect, useReducer } from 'react';

import {
  Typography,
  notification,
  Tabs,
  Select,
  Modal,
  Row,
  Col,
  Radio,
  Form,
  Input,
  Alert,
} from 'antd';
import dayjs from 'dayjs';
import { CustomButton, CustomSelector } from '../../components';
import MESSAGES from '../../enums/Messages';
import { Link } from 'react-router-dom';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import AjaxTable from '../../components/AjaxTable';
import Paragraph from 'antd/lib/typography/Paragraph';
import {
  getProjects,
  getRoles,
  getTerms,
  getMassIDs,
  ajaxTable as filterAjaxTable,
  contractorTable,
} from '../../api/module/product_approval';

import '../../styles/main.scss';
import INTERNAL_LINKS from '../../enums/InternalLinks';

const { Title } = Typography;
const { TabPane } = Tabs;

const breadcrumbItems = [
  {
    text: 'Aprobación de productos y/o entregables y gastos',
  },
];

const initSelectors = {
  estado_proyecto: 1,
  proyecto: undefined,
  cargo: undefined,
  termino: undefined,
  mass_ctm: undefined,
};

function reducer(state, action) {
  switch (action.type) {
    case 'ps':
      return {
        ...initSelectors,
        estado_proyecto: action.payload,
      };
    case 'project':
      return {
        estado_proyecto: state.estado_proyecto,
        proyecto: action.payload,
      };
    case 'role':
      return {
        ...state,
        cargo: action.payload,
        termino: initSelectors.termino,
        mass_ctm: initSelectors.mass_ctm,
      };
    case 'termino':
      return {
        ...state,
        termino: action.payload,
        mass_ctm: initSelectors.mass_ctm,
      };
    case 'mass_ctm':
      return { ...state, mass_ctm: action.payload };

    default:
      return initSelectors;
  }
}

function ProductApprovalHomeSelectors({ match, setQuery }) {
  const [state, dispatch] = useReducer(reducer, initSelectors);

  useEffect(() => {
    if (!match.params.type || Object.values(state).some((value) => !!value)) {
      let q = '';
      if (q === '' && state.mass_ctm) {
        q = `filter[mass_ctm]=${state.mass_ctm}`;
      }
      if (q === '' && state.termino) {
        q = `filter[termino]=${state.termino}`;
      }
      if (q === '' && state.cargo) {
        q = `filter[cargo]=${state.cargo}`;
      }
      if (q === '' && state.tipo_contrato) {
        q = `filter[tipo_contrato]=${state.tipo_contrato}&filter[proyecto]=${state.proyecto}`;
      }
      if (q === '' && state.proyecto) {
        q = `filter[proyecto]=${state.proyecto}`;
      }
      setQuery({ query: q, param: state });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <div className="box-description" key="pa-selectors">
      <Row className="box-selectors">
        <Col span={6}>
          <Title level={4}>Estado del proyecto a revisar:</Title>
        </Col>
        <Col span={17} offset={1}>
          <Select
            options={[
              { value: 1, label: 'Activo' },
              { value: 2, label: 'Cerrado técnico' },
              { value: 3, label: 'Cerrado administrativo y jurídico' },
              { value: 0, label: 'Todos los proyectos' },
            ]}
            onChange={(value) => dispatch({ type: 'ps', payload: value })}
            style={{ width: '100%' }}
            key={match.url}
            defaultValue={initSelectors.estado_proyecto}
          />
        </Col>
      </Row>
      {(state.estado_proyecto || state.estado_proyecto === 0) && (
        <Row className="box-selectors">
          <Col span={6}>
            <Title level={4}>Proyecto a revisar:</Title>
          </Col>
          <Col span={17} offset={1}>
            <CustomSelector
              onChange={(value) =>
                dispatch({ type: 'project', payload: value })
              }
              initialValue={
                match.params.type && match.params.type === 'project'
                  ? parseInt(match.params.id)
                  : undefined
              }
              onLoad={(value) => {
                if (match.params.type === 'project')
                  dispatch({
                    type: 'project',
                    payload: value ? value.value : undefined,
                  });
              }}
              selectorProps={{
                style: { width: '100%' },
                placeholder: 'Seleccione el proyecto a revisar...',
              }}
              endpointFetch={async () => {
                return await getProjects({
                  'filter[estado_proyecto]': state.estado_proyecto,
                });
              }}
              key={`rs-${state.estado_proyecto}`}
            />
          </Col>
        </Row>
      )}
      {state.proyecto && (
        <Row className="box-selectors">
          <Col span={6}>
            <Title level={4}>Cargo/rol a revisar:</Title>
          </Col>
          <Col span={17} offset={1}>
            <CustomSelector
              onChange={(value) => dispatch({ type: 'role', payload: value })}
              initialValue={
                match.params.type && match.params.type === 'role'
                  ? parseInt(match.params.id)
                  : undefined
              }
              onLoad={(value) => {
                if (match.params.type === 'role')
                  dispatch({
                    type: 'role',
                    payload: value ? value.value : undefined,
                  });
              }}
              selectorProps={{
                style: { width: '100%' },
                placeholder: 'Seleccione el Cargo / Rol a revisar... ',
              }}
              endpointFetch={async () => {
                return await getRoles({
                  'filter[proyecto]': state.proyecto,
                });
              }}
              key={`rs-${state.proyecto}`}
            />
          </Col>
        </Row>
      )}
      {state.cargo && (
        <Row className="box-selectors" align="middle">
          <Col span={6}>
            <Title level={4} style={{ paddingRight: '15px' }}>
              Identificador del término a revisar:
            </Title>
          </Col>
          <Col span={17} offset={1}>
            <CustomSelector
              onChange={(value) =>
                dispatch({ type: 'termino', payload: value })
              }
              initialValue={
                match.params.type && match.params.type === 'termino'
                  ? parseInt(match.params.id)
                  : undefined
              }
              onLoad={(value) => {
                if (match.params.type === 'termino')
                  dispatch({
                    type: 'termino',
                    payload: value ? value.value : undefined,
                  });
              }}
              selectorProps={{
                style: { width: '100%' },
                placeholder: 'Seleccione el identificador del término... ',
              }}
              endpointFetch={async () => {
                return await getTerms({
                  'filter[cargo]': state.cargo,
                });
              }}
              key={`rs-${state.cargo}`}
            />
          </Col>
        </Row>
      )}
      {state.termino && (
        <Row className="box-selectors" align="middle">
          <Col span={6}>
            <Title level={4} style={{ paddingRight: '15px' }}>
              Identificador interno de la Modificación masiva:
            </Title>
          </Col>
          <Col span={17} offset={1}>
            <CustomSelector
              onChange={(value) =>
                dispatch({ type: 'mass_ctm', payload: value })
              }
              initialValue={
                match.params.type && match.params.type === 'mass_ctm'
                  ? match.params.id
                  : undefined
              }
              onLoad={(value) => {
                if (match.params.type === 'mass_ctm')
                  dispatch({
                    type: 'mass_ctm',
                    payload: value ? value.value : undefined,
                  });
              }}
              selectorProps={{
                style: { width: '100%' },
                placeholder:
                  'Seleccione el identificador masivo de la liquidación... ',
              }}
              endpointFetch={async () => {
                return await getMassIDs({
                  'filter[termino]': state.termino,
                });
              }}
              labelName="value"
              key={`rs-${state.termino}`}
            />
          </Col>
        </Row>
      )}
      {state.cargo && (
        <Alert
          showIcon
          type="info"
          message="Cargue masivo"
          description="Si desea aprobar productos masivamente por Proyecto y Cargo, ingrese al siguiente botón y descargue el excel"
          action={
            <Link to={`${INTERNAL_LINKS.MASS_PRODUCT_APPROVAL}/${state.cargo}`}>
              <CustomButton htmlType="button" text="Masivo" />
            </Link>
          }
        />
      )}
    </div>
  );
}

export default function ProductApprovalHome({ match, history }) {
  const [query, setQuery] = useState({ q: '', param: {} });
  const [modalData, setModalData] = useState(undefined);

  const [searchForm] = Form.useForm();
  const [searchQuery, setSearchQuery] = useState(undefined);
  const [contractorID, setContractorID] = useState(
    match.params.type && match.params.type === 'person'
      ? parseInt(match.params.id)
      : undefined,
  );

  async function changeQuery(q = { query: '', param: undefined }) {
    try {
      if (q !== query) setQuery(q);
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_GET_MSG,
        duration: 2,
      });
    }
  }

  const ViewApproveButton = ({ record, fromPerson = false }) => {
    const text = record.pending_ctm
      ? 'Ver restricción'
      : !record.pending_pa || record.has_pc
        ? 'Ver'
        : 'Aprobar';
    return (
      <>
        {record.pending_svdp ||
        record.pending_insurance ||
        record.pending_ctm ? (
          <CustomButton
            type="primary"
            htmlType="button"
            text={text}
            onClick={() => onCheckup(record, fromPerson)}
          />
        ) : (
          <Link
            to={`${INTERNAL_LINKS.PRODUCT_APPROVAL}-form/${record.id}${
              fromPerson ? '/?person=True' : ''
            }`}
          >
            <CustomButton type="primary" htmlType="button" text={text} />
          </Link>
        )}
      </>
    );
  };

  const columnsByProject = [
    {
      title: 'Nombres y Apellidos',
      dataIndex: 'nombre_completo',
    },
    {
      title: 'Tipo doc',
      dataIndex: 'tipo_identificacion',
    },
    {
      title: 'Nro. documento',
      dataIndex: 'numero_identificacion',
    },
    {
      title: 'Cargo',
      dataIndex: 'cargo_nombre',
    },
    {
      title: 'Nro. Contrato',
      dataIndex: 'numero_contrato',
      align: 'center',
    },
    {
      title: 'Subcentro de costos',
      dataIndex: 'centro_costo_nombre',
    },
    {
      title: 'Última fecha aprobación',
      dataIndex: 'fecha_aprobacion',
      align: 'center',
      render: (t) => (t ? dayjs(t).format('DD MMMM YYYY HH:mm') : null),
    },
    {
      title: 'Hecha por',
      dataIndex: 'aprobador_nombre',
      align: 'center',
    },
    {
      title: 'Acciones',
      key: 'actions',
      fixed: 'right',
      align: 'center',
      render: (_, record) => <ViewApproveButton record={record} />,
    },
  ];

  const onCheckup = (record, fromPerson = false) => {
    if (record.pending_ctm)
      Modal.error({
        title: 'Advertencia',
        content:
          'Este contratista tiene una Modificación en proceso, no se pueden realizar aprobaciones hasta que esta termine.',
      });
    else setModalData({ ...record, fromPerson: fromPerson });
  };

  const renderPOrC = (props) => {
    return (
      <Radio.Group
        name="porc"
        value={props.activeKey}
        key="porc"
        onChange={(e) => props.onTabClick(e.target.value)}
      >
        <Radio value="proyecto">Proyecto</Radio>
        <Radio value="contratista">Contratista</Radio>
      </Radio.Group>
    );
  };

  const columnsContractor = [
    {
      title: 'Nombres y Apellidos',
      dataIndex: 'nombre_completo',
    },
    {
      title: 'Tipo documento',
      dataIndex: 'tipo_identificacion',
      align: 'center',
    },
    {
      title: 'Nro. documento',
      dataIndex: 'identificacion',
    },
    {
      title: 'Acciones',
      dataIndex: 'id',
      align: 'center',
      render: (t) => (
        <CustomButton
          type="primary"
          htmlType="button"
          text="Ver"
          onClick={() => setContractorID(t)}
        />
      ),
    },
  ];

  const columnsByContractor = [
    {
      title: 'Proyecto',
      dataIndex: 'proyecto_nombre',
    },
    {
      title: 'Estado proyecto',
      dataIndex: 'proyecto_estado',
    },
    {
      title: 'Cargo',
      dataIndex: 'cargo_nombre',
    },
    {
      title: 'Nro. Contrato',
      dataIndex: 'numero_contrato',
      align: 'center',
    },
    {
      title: 'Subcentro de costos',
      dataIndex: 'centro_costo_nombre',
    },
    {
      title: 'Última fecha aprobación',
      dataIndex: 'fecha_aprobacion',
      align: 'center',
      render: (t) => (t ? dayjs(t).format('DD MMMM YYYY HH:mm') : null),
    },
    {
      title: 'Hecha por',
      dataIndex: 'aprobador_nombre',
      align: 'center',
    },
    {
      title: 'Estado contrato',
      dataIndex: 'estado_contrato',
    },
    {
      title: 'Acciones',
      key: 'actions',
      fixed: 'right',
      render: (_, record) => (
        <ViewApproveButton fromPerson={true} record={record} />
      ),
    },
  ];

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Aprobación de productos y/o entregables y gastos
      </Title>
      <Tabs
        renderTabBar={renderPOrC}
        style={{ marginTop: 30 }}
        defaultActiveKey={
          match.params.type && match.params.type === 'person'
            ? 'contratista'
            : 'proyecto'
        }
      >
        <TabPane tab="Proyecto" key="proyecto" tabKey="">
          <ProductApprovalHomeSelectors match={match} setQuery={changeQuery} />
          {query.param.proyecto ? (
            <Tabs
              style={{ marginTop: 15 }}
              defaultActiveKey="pending"
              destroyInactiveTabPane={true}
              type="card"
              key={`pa-home-tabs-${query.query}`}
            >
              <TabPane
                tab={
                  <Paragraph>
                    Contratistas pendientes por aprobación de productos
                    {/* <Badge showZero count={counters.pending} /> */}
                  </Paragraph>
                }
                key="pending"
              >
                <AjaxTable
                  columns={columnsByProject}
                  tableTitle={
                    'Contratistas pendientes por aprobación de productos'
                  }
                  endpoint={filterAjaxTable}
                  query={`/?${query.query}&filter[tipo_lista]=1`}
                  searchInput
                  exportCSV
                />
              </TabPane>
              <TabPane
                tab={
                  <Paragraph>
                    Todos los contratistas
                    {/* <Badge showZero count={counters.approved} /> */}
                  </Paragraph>
                }
                key="all"
              >
                <AjaxTable
                  columns={columnsByProject}
                  tableTitle={'Todos los contratistas'}
                  endpoint={filterAjaxTable}
                  query={`/?${query.query}&filter[tipo_lista]=0`}
                  searchInput
                  exportCSV
                />
              </TabPane>
            </Tabs>
          ) : null}
        </TabPane>
        <TabPane tab="Contratista" key="contratista">
          <br />
          <Form
            form={searchForm}
            layout="vertical"
            onFinish={(values) => {
              setSearchQuery(values);
              setContractorID();
            }}
          >
            <Title level={5}>Búsqueda por identificación</Title>
            <Row align="bottom" gutter={8}>
              <Col span={8}>
                <Form.Item label="Nombre" name="nombre">
                  <Input allowClear placeholder="Búsqueda por nombre" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Número de documento" name="documento">
                  <Input
                    type="number"
                    allowClear
                    placeholder="Búsqueda por documento"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Correo electrónico" name="correo">
                  <Input allowClear placeholder="Correo electrónico" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={8} justify="start">
              <Col>
                <CustomButton text="Buscar" />
              </Col>
              <Col>
                <CustomButton
                  htmlType="button"
                  type="default"
                  onClick={() => {
                    searchForm.resetFields();
                    setSearchQuery();
                    setContractorID();
                  }}
                  danger={true}
                  text="Borrar filtros"
                />
              </Col>
            </Row>
          </Form>
          {searchQuery ? (
            <AjaxTable
              columns={columnsContractor}
              endpoint={contractorTable}
              query={searchQuery}
            />
          ) : null}
          <br />
          {contractorID ? (
            <Tabs
              style={{ marginTop: 15 }}
              defaultActiveKey="active"
              destroyInactiveTabPane={true}
              type="card"
              key={`pa-home-contractor-${contractorID}`}
            >
              <TabPane
                tab={
                  <Paragraph>
                    Proyectos activos
                    {/* <Badge showZero count={counters.pending} /> */}
                  </Paragraph>
                }
                key="active"
              >
                <AjaxTable
                  columns={columnsByContractor}
                  endpoint={filterAjaxTable}
                  query={`/?filter[contratista]=${contractorID}&filter[estado_proyecto]=1`}
                  searchInput
                  exportCSV
                />
              </TabPane>
              <TabPane
                tab={
                  <Paragraph>
                    Proyectos Cerrados
                    {/* <Badge showZero count={counters.approved} /> */}
                  </Paragraph>
                }
                key="closed"
              >
                <AjaxTable
                  columns={columnsByContractor}
                  endpoint={filterAjaxTable}
                  query={`/?filter[contratista]=${contractorID}&filter[estado_proyecto]=4`}
                  searchInput
                  exportCSV
                />
              </TabPane>
              <TabPane
                tab={
                  <Paragraph>
                    Todos los proyectos
                    {/* <Badge showZero count={counters.approved} /> */}
                  </Paragraph>
                }
                key="all"
              >
                <AjaxTable
                  columns={columnsByContractor}
                  endpoint={filterAjaxTable}
                  query={`/?filter[contratista]=${contractorID}&filter[estado_proyecto]=0`}
                  searchInput
                  exportCSV
                />
              </TabPane>
            </Tabs>
          ) : null}
        </TabPane>
      </Tabs>
      <Modal
        open={modalData?.id}
        cancelText="No"
        okText="Si"
        onCancel={() => setModalData()}
        onOk={() =>
          history.push(
            `${INTERNAL_LINKS.PRODUCT_APPROVAL}-form/${modalData.id}${
              modalData.fromPerson ? '/?person=True' : ''
            }`,
          )
        }
        title={
          <Title level={4} style={{ marginBottom: 0 }}>
            Advertencia
          </Title>
        }
      >
        <>
          Este contratista tiene los siguientes pendientes:
          <ul>
            {modalData?.pending_svdp ? (
              <li>
                Documentos pendientes por validar en Seguimiento Validación
                Parcial
              </li>
            ) : null}
            {modalData?.pending_insurance ? <li>Póliza</li> : null}
          </ul>
          Es posible que no se pueda continuar con el trámite del pago.
          <br />
          ¿Desea continuar?
        </>
      </Modal>
    </>
  );
}
